import{useEffect}from"react";var useUnmount=function(callback){useEffect(function(){return callback},[])};export default useUnmount;
//# sourceMappingURL=useUnmount.js.map